import React from "react";

const HStatCard = ({ title, value, details, detailsColor, subDetails, progressBarValue, icon, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="bg-white p-3 sm:p-6 rounded-[12.75px] border border-gray-200 relative overflow-hidden">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <div className="h-4 w-24 bg-gradient-to-r from-gray-200 to-gray-300 rounded animate-pulse mb-2"></div>
            <div className="h-8 w-16 bg-gradient-to-r from-gray-200 to-gray-300 rounded animate-pulse mb-2"></div>
            <div className="h-3 w-32 bg-gradient-to-r from-gray-200 to-gray-300 rounded animate-pulse"></div>
          </div>
          <div className="w-8 h-8 bg-gradient-to-br from-gray-200 to-gray-300 rounded animate-pulse"></div>
        </div>
        {/* Shimmer effect */}
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent"></div>
      </div>
    );
  }

  return (
    <div className="bg-white p-3 sm:p-6 rounded-[12.75px] border border-gray-200 transition-all duration-300 hover:shadow-lg">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-xs sm:text-sm font-medium text-gray-500">{title}</h3>
          <p className="mt-1 text-xl sm:text-3xl font-semibold text-gray-900">{value}</p>
          {details && <p className={`mt-1 text-xs ${detailsColor || "text-gray-500"}`}>{details}</p>}
          {subDetails && (
            <p className="mt-1 text-xs">
              {subDetails.map((item, index) => (
                <span key={index} className={`${item.color} ${index > 0 ? "ml-2" : ""}`}>
                  {item.text}
                </span>
              ))}
            </p>
          )}
        </div>
        {icon && <div className="text-muted-foreground scale-75 sm:scale-100">{icon}</div>}
      </div>
      {progressBarValue !== undefined && (
        <div className="mt-2">
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="h-2 rounded-full transition-all duration-500"
              style={{
                width: `${progressBarValue}%`,
                backgroundColor: "#000000",
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HStatCard;
